/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


const buildArgs = ({ account, args }) =>
{
  const payload = {};

  payload.galaxy = account.cass.galaxy;
  payload.draft = args.draft;

  return payload;
};


const validate = ({ account, args }) =>
{
  const issues = [];

  if (args.draft !== null && account.getColonyDraft(args.draft) === null)
  {
    issues.push('Colony draft doesn\'t exist');
  }

  return { valid: args.draft !== null && issues.length === 0, issues };
};


const isAvailable = ({ account }) =>
{
  return account.cass.colonyCounter === 0;
};


export default
{
  type: 'solis/colony/create',
  scope: 'createColony',
  inputs: { draft: null },

  isAvailable,
  buildArgs,
  validate,
};
